import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

export const DEFAULT_API_TIMEOUT = 1_000 * 60 * 5;

export const BASE_PATH = MONOLITH_ORIGIN;

export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

export const GLOBAL_REQUEST_INTERCEPTORS = [];

export const GLOBAL_RESPONSE_INTERCEPTORS = [];
